import { render, staticRenderFns } from "./SellerWarning.vue?vue&type=template&id=19d54438&"
import script from "./SellerWarning.vue?vue&type=script&lang=js&"
export * from "./SellerWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports